<template>
    <div class="credit-debit-tab">
        <BasePanel>
            <template #content>
                <template v-if="!successful">
                    <div class="amount-to">
                        <h3 class="title title__medium">{{ tokens.newDesign.amountToWithdrawal }}</h3>
                        <div class="inputs-list">
                            <BaseInput v-model="amount" :type="'number'" :title="tokens.newDesign.amount" :placeholder="'0.00'">
                                <template #icon>
                                    <p class="body__large">{{currencySign(activeAccount.currency)}}</p>
                                </template>
                                <template #info>
                                    <p class="body__large">{{ activeAccount.currency }}</p>
                                </template>
                            </BaseInput>
                        </div>
                    </div>
                    <div class="bank-details">
                        <h3 class="title title__medium">{{ tokens.fullScreenWithdrawal.bankDetails }}</h3>
                        <div class="inputs-list">
                            <BaseInput v-model="contact" :title="tokens.fullScreenWithdrawal.contactNumberOrEmail"/>
                            <BaseInput v-model="name" :title="tokens.fullScreenWithdrawal.firstAndLastNameZelle"/>
                        </div>
                    </div>
                    <div class="confirm">
                        <SendWithdrawal
                            :disabled="!amount || !name || !contact"
                            :info="getInfo"
                            @send="showSuccessful()"
                        />
                    </div>
                </template>
                <template v-else>
                    <SuccessfulTab
                        :details="getDetails"
                        @closeSuccessfullTab="closeSuccessfullTab"
                        @showAccounts="showAccounts"
                    />
                </template>
            </template>
        </BasePanel>
    </div>
</template>

<script>
import BasePanel from "@/new-design/shared/ui/panels/BasePanel.vue"
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput.vue"
import SendWithdrawal from "@/new-design/features/Withdrawal/ui/SendWithdrawal.vue"
import {mapGetters} from "vuex"
import SuccessfulTab from "@/new-design/pages/withdrawal/tabs/SuccessfulTab.vue"
import {currencySign} from "@/common/helpers"
import {MODAL, MODAL_FULLSCREEN} from "@/store/mutations.type"

export default {
    name: "CreditDebitTab",
    components: {SuccessfulTab, SendWithdrawal, BaseInput, BasePanel},
    mounted() {
        this.init()
    },
    data() {
        return {
            amount: null,
            contact: "",
            name: "",
            successful: false,
        }
    },
    methods: {
        init() {
            this.amount = null
            this.contact = null
            this.name = ''
            this.successful = false
        },
        showSuccessful() {
            this.init()
            this.successful = true
        },
        showAccounts() {
            this.$store.commit(MODAL, {
                fullscreen: true
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

            this.$store.commit(MODAL_FULLSCREEN, {
                page: 'accounts'
            })
        },
        closeSuccessfullTab() {
            this.init()
            this.successful = false
        },
        currencySign
    },
    computed: {
        ...mapGetters(['activeAccount','tokens']),
        getInfo() {
            return {
                method: 'zelle',
                amount: this.amount,
                contact: this.contact,
                name: this.name,
                activeAccount: this.activeAccount
            }
        },
        getDetails() {
            return [
                {
                    title: 'Amount withdrawn',
                    value: currencySign(this.activeAccount.currency) + ' ' + this.amount,
                },
                {
                    title: 'Currency',
                    value: this.activeAccount.currency
                },
                {
                    title: 'Time',
                    value: this.formattedWithdrawalTime
                },
                {
                    title: 'Transaction status',
                    value: 'Processing'
                },
            ]
        },
        formattedWithdrawalTime() {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }
            return new Date().toLocaleString('en-GB', options).replace(',', '')
        },
    }
}
</script>


<style scoped>
.title {
    color: var(--System-OnSurface);
    margin-bottom: 16px;
}

.amount-to,
.card-details {
    margin-bottom: 16px;
}

.cards-list {
    display: flex;
    align-items: center;
    gap: 4px;
}

.inputs-list {
    display: flex;
    gap: 20px;
    flex-direction: column;
}

.confirm {
    margin-top: 24px;
    width: 100%;
    text-align: right;
}
</style>
